import _padStart from 'lodash/padStart'
import _startsWith from 'lodash/startsWith'
import _toUpper from 'lodash/toUpper'
import _trim from 'lodash/trim'

// ex: 9780000555014
// becomes: 0000555010
export function convert978ToISBN10(incoming13) {
  const incoming13Str: string = _trim(`${incoming13}`) || ''

  if (incoming13Str.length === 13) {
    // take 4-12th digits
    const isbn9: string = incoming13Str.substr(3, 9)
    let sum: number = 0

    for (let i = 0; i < isbn9.length; i++) {
      sum += parseInt(isbn9[i], 10) * (10 - i)
    }

    const modulus: number = 11
    const remainder: number = sum % modulus
    let checkdigit: any = modulus - remainder

    if (checkdigit === 10) {
      checkdigit = 'X'
    } else if (checkdigit === 11) {
      checkdigit = 0
    }

    return `${isbn9}${checkdigit}`
  } else {
    return incoming13Str
  }
}

// in:  0008101590
// out: 9780008101596
export function convertISBN10To978(incoming10) {
  const incoming10Str: string = _trim(`${incoming10}`) || ''
  const regEx = new RegExp('^[0-9x]+$')

  if (incoming10Str.length === 10 && regEx.test(incoming10Str)) {
    // take 1-9th digits
    const isbn9: string = incoming10Str.substr(0, 9)
    // prepend with 978
    const isbn12: string = _padStart(isbn9, 12, '978')
    let sum: number = 0

    for (let i = 0; i < isbn12.length; i++) {
      if (i % 2 === 0) {
        // positions: 0,2,4,6,8 - multiply by 1
        sum += parseInt(isbn12[i], 10)
      } else {
        // positions: 1,3,5,7 - multiply by 3
        sum += parseInt(isbn12[i], 10) * 3
      }
    }

    const remainder: number = sum % 10
    let checkdigit: number = 10 - remainder

    if (checkdigit === 10) {
      checkdigit = 0
    }

    const isbn13 = `${isbn12}${checkdigit}`
    return isbn13
  } else {
    return incoming10Str
  }
}

// take an EAN like '2901285177198' and convert it to '9781285177199'
// 2900393149745
export function fixEAN290(value) {
  const valueStr = `${value}` || ''
  if (valueStr.length === 13 && _startsWith(valueStr, '290')) {
    return convert978ToISBN10(valueStr)
  }
  return valueStr
}

export function isValidISBN(isbn) {
  const isbnStr: string = _toUpper(`${isbn}`) || ''

  if (isbnStr.length === 13) {
    const isbn12: string = isbnStr.substr(0, 12)
    const checkdigitStart: string = isbnStr.substr(12, 1)
    let sum: number = 0

    for (let i = 0; i < isbn12.length; i++) {
      if (i % 2 === 0) {
        // positions: 0,2,4,6,8 - multiply by 1
        sum += parseInt(isbn12[i], 10)
      } else {
        // positions: 1,3,5,7 - multiply by 3
        sum += parseInt(isbn12[i], 10) * 3
      }
    }

    const remainder: number = sum % 10
    let checkdigitEnd: number = 10 - remainder

    if (checkdigitEnd === 10) {
      checkdigitEnd = 0
    }

    if (checkdigitStart === `${checkdigitEnd}`) {
      // its valid
      return true
    } else {
      // not valid
      return false
    }
  } else if (isbnStr.length === 10) {
    // take 1-9th digits
    const isbn9: string = isbnStr.substr(0, 9)
    const checkdigitStart: string = isbnStr.substr(9, 1)
    let sum: number = 0

    for (let i = 0; i < isbn9.length; i++) {
      sum += parseInt(isbn9[i], 10) * (10 - i)
    }

    const modulus: number = 11
    const remainder: number = sum % modulus
    let checkdigitEnd: any = modulus - remainder

    if (checkdigitEnd === 10) {
      checkdigitEnd = 'X'
    } else if (checkdigitEnd === 11) {
      checkdigitEnd = 0
    }

    if (checkdigitStart === `${checkdigitEnd}`) {
      // its valid
      return true
    } else {
      // not valid
      return false
    }
  }
  return false
}

// 2900393149745
export function normalizeISBN(isbn) {
  const isbnStr: string = `${isbn}`
  if (isbnStr.length === 13) {
    if (_startsWith(isbnStr, '978')) {
      return isbnStr
    }

    if (_startsWith(isbnStr, '290')) {
      // convert to isbn 10
      const isbn10: string = convert978ToISBN10(isbnStr)
      // convert back to isbn 13
      return convertISBN10To978(isbn10)
      // take an EAN like '2901285177198' and convert it to '9781285177199'
      // 2900393149745
    }

    return convertISBN10To978(isbnStr)
  } else {
    return convertISBN10To978(isbnStr)
  }
}
